import * as url from "../../helpers/url_helper";
import { apiCall, fetchApi } from "./apiService";

/**
 * Creates campaigns from CSV data
 * @param {string} shop - Shop domain
 * @param {Array} campaigns - Array of campaign objects
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const createCampaigns = async (shop, campaigns, notifyError) => {
    return await apiCall(
        url.CREATE_CAMPAIGN,
        'POST',
        {
            shop,
            campaigns
        },
        notifyError,
        "Failed to create campaigns"
    );
};

/**
 * Gets campaign list for a shop
 * @param {string} shop - Shop domain
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Array|null>} Array of campaigns or null if error
 */
export const getCampaignList = async (shop, notifyError) => {
    try {
        const endpoint = `${url.CAMPAIGN_LIST}?shop=${encodeURIComponent(shop)}`;
        const { response, results } = await fetchApi(endpoint, 'GET');

        if (response.ok && results?.status && results?.data) {
            return results.data;
        }
        return null;
    } catch (error) {
        if (notifyError) {
            notifyError("Failed to load campaigns");
        }
        return null;
    }
};

